import type { FC } from 'react';
import { Spinner } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { useDeleteProductItem } from '../../../../bff-api/baskets/useDeleteProductItem';
import { Button } from '../../../../ui-components';
import type { ProductItem } from '../../../../bff-api/baskets/model';

interface DeleteProductItemButtonProps {
    productItem: ProductItem;
}

export const DeleteProductItemButton: FC<DeleteProductItemButtonProps> = ({ productItem }) => {
    const mutation = useDeleteProductItem('BAG');

    const { itemId } = productItem;

    return (
        <div className="flex items-center gap-1">
            <Button
                id={`cart-item-remove-button-${itemId}`}
                variant="text-button-no-hover"
                textSize="base"
                onClick={() => {
                    mutation.mutate({ itemId, productItem });
                }}
                isDisabled={mutation.isLoading}
            >
                <FormattedMessage id="cart.item.secondary_buttons.remove" defaultMessage="Remove" />
            </Button>
            {mutation.isLoading ? (
                <Spinner
                    data-testid="cart-item-remove-button-loading"
                    size="xs"
                    color="slt-pepper.1000"
                />
            ) : null}
        </div>
    );
};
